import { ElButton, ElDialog } from 'element-plus'
import { computed, defineComponent, h, ref, watch } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isDialogVisible = ref(false)

    const title = computed(() => props.context?.attrs?.title || 'Dialog Title')
    const content = computed(() => props.context?.attrs?.content || 'Default Dialog Content')
    const width = computed(() => props.context?.attrs?.width || '50%')
    const triggerKey = computed(() => props.context?.attrs?.triggerKey)
    watch(
      () => props.context.node.parent?.value?.[triggerKey.value],
      (newValue) => {
        isDialogVisible.value = !!newValue
      },
    )

    return () =>
      h('div', { class: 'mb-4' }, [
        h(
          ElDialog,
          {
            modelValue: isDialogVisible.value,
            'onUpdate:modelValue': (val) => (isDialogVisible.value = val),
            title: title.value,
            width: width.value,
          },
          {
            default: () => h('div', { class: 'p-4' }, content.value),
            footer: () =>
              h(
                'div',
                { class: 'text-right' },
                h(
                  ElButton,
                  {
                    type: 'primary',
                    onClick: () => (isDialogVisible.value = false),
                  },
                  () => 'Close',
                ),
              ),
          },
        ),
      ])
  },
})
